import React from "react";
// import Resturant from "./component/Basics/Resturant";cd 
// import UseState from "./component/Hooks/useState";
// import UseEffect from "./component/Hooks/useEffect";
// import useReducer from "./component/Hooks/useReducer";
// import UseReducer from "./Component/Hooks/useReducer.js"
// import Todo from "./Component/Todoreact/todo";
import Todo from "./Component/Todoreact/todo";

const App = () => {
  return <>
    <Todo />
  </>;
};

export default App;